import type { FaireProductEntity } from "../../entity_types/product";

export const p_xm8kf92nm8: FaireProductEntity = {
  token: "p_xm8kf92nm8",
  type: "product",
  name: "Mini Candle Discovery Kit - 3 Hand Poured Candles",
  brandName: "Little Mountain Home",
  imageUrl:
    "https://cdn.faire.com/fastly/54d09b738fd8b25c11ffc5009da622968c69bd8fe8fc22cd46e7c1a3d18e3526.jpeg",
  priceDollars: 18.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/891cabd516279f3c43cdf7594ed4504b3e8cb627d47602c2709b8a74bab6dd18.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
